import * as types from 'constants/ActionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {Array<import('modules/statistics/types').RevenueByBrandReducer>} */
const initialState = [];

/**
 * @param {Array<import('modules/statistics/types').RevenueByBrandReducer>} _
 * @param {import('modules/statistics/types').FetchRevenueByBrandStatsSuccessAction} action
 * @returns {Array<import('modules/statistics/types').RevenueByBrandReducer>}
 */
const updateAllData = (_, { payload }) => payload.content;

export default createReducer(initialState, {
  [types.FETCH_STATISTICS_REVENUE_BY_BRAND_STATS_SUCCESS]: updateAllData,
});
